import React, { useEffect, useState } from 'react'
import Skeleton from "react-loading-skeleton";
import moment from 'moment';
import { formatNumber } from '../utils/data/essential';
import { baseUrl } from '../utils/apiActions/dashboardApi';
import { Tooltip } from 'react-tippy';
import DisplayAgent from './agents/DisplayAgent';

const AccountDetails = ({ account }) => {
  const [locations, setLocations] = useState();
  const [agent, setAgent] = useState();
  const [show, setShow] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  // Fetch location details
  useEffect(() => {
    if (account) {
      const { locationId } = account;
        fetch(`${baseUrl}/locations/${locationId}/details`, {
          method: "GET",
          headers: new Headers({
            Authorization: "Bearer " + user.access_token,
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLocations(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
  }, [account]);
   // Fetch Agent
  const fetchAgent = () => {
    if (account) {
      const { locationId } = account;
      fetch(`${baseUrl}/agents?locationId=${locationId}`, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + user.access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          // Check active agent who matches location id
          const today = new Date();
          const matchedAgent = res?.find((item) => {
            return item.locations.some(
              (location) =>
                location.locationId === locationId &&
                new Date(location.endDatetime) > today
            );
          });
          setAgent(matchedAgent);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  useEffect(() => {
    fetchAgent();
  },[account])
  return (
    <div>
      <div className='d-flex flex-wrap' style={{ gap: 10 }}>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Id
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.id ? account?.id : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Names
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.accountName ? account?.accountName : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Account Nbr
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.accountNumber ? account?.accountNumber : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#000", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            OwnerId
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.subscriberId ? account?.subscriberId : <Skeleton />}
            </p>
          </div>
        </div>
        <div
          onClick={() => {
            setShow(true);
          }}
        >
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Location
          </p>
          {locations?.length > 0 && (
            <Tooltip
              position='bottom'
              title={`${locations[1]?.name},${locations[2]?.name},${locations[3]?.name},${locations[4]?.name}`}
              trigger='mouseenter'
            >
              <div
                className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
                style={{
                  backgroundColor: "#FFF",
                  borderRadius: 5,
                  height: 50,
                  cursor: "pointer",
                }}
              >
                <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
                  {locations[locations.length - 1]?.name ? (
                    locations[locations.length - 1]?.name
                  ) : (
                    <Skeleton />
                  )}
                </p>
              </div>
            </Tooltip>
          )}
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Monthly Fee
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.monthlyFee != null ? (
                `${formatNumber(account?.monthlyFee)} RWF`
              ) : (
                <Skeleton />
              )}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Outstanding
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.outstandingAmount != null ? (
                `${formatNumber(account?.outstandingAmount)} RWF`
              ) : (
                <Skeleton />
              )}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Type
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {account?.type?.name ? account?.type?.name : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Status
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-1'>
              {account?.status ? account?.status?.name : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Created On
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p
              style={{
                fontSize: 20,
                color: "#878793",
              }}
              className='ml-3'
            >
              {account?.createdAt ? (
                moment(account?.createdAt).format("DD-MM-YYYY")
              ) : (
                <Skeleton />
              )}
            </p>
          </div>
        </div>
      </div>
      <DisplayAgent agent={agent} show={show} hide={() => setShow(false)} />
    </div>
  );
}

export default AccountDetails